module.exports = __webpack_public_path__ + "img/qzebg.2c5c08a1.jpg";